import { AxiosResponse, InternalAxiosRequestConfig } from "axios";

export const requestInterceptor = (req: InternalAxiosRequestConfig) => ({
  ...req,
});

export const responseInterceptor = (res: AxiosResponse) => res;
